/**
 * **Was diese Installation kann** -- soweit die Oberfläche es wissen muss
 * (7.159).
 *
 * Sascha, 24. September: „Ist alles was Box.com war inzwischen auf nextcloud
 * umgestellt? Ich sehe immer noch Spuren“. Box ist der alte Weg (7.23) und an
 * seiner Installation gar nicht eingerichtet -- trotzdem fragte das Anlegen
 * nach einer Box-Ordner-ID, und jedes Projekt zeigte in seinen Einstellungen
 * einen Box-Ordner. Die Auskunft kommt mit `/api/auth/me` und steht hier,
 * damit jede Stelle sie ohne eigene Anfrage fragen kann.
 *
 * Ohne Auskunft gilt „kein Box“: ein Feld, das fehlt, obwohl es ginge, ist
 * harmloser als eines, das ins Leere führt.
 */
let box = false;

export function setzeInstallation(stand: { box: boolean } | undefined): void {
  box = Boolean(stand?.box);
}

export function boxEingerichtet(): boolean {
  return box;
}
